import React from 'react';
import { TextButton } from '../TextButton';
import './FormatErrorMessage.scss';
import { useLocale } from '../../locale/LocaleContext';
export const FormatErrorMessage = React.memo(({ onCancelClick, children }) => {
    const l10n = useLocale('fileStep');
    return (React.createElement("div", { className: "CSVImporter_FormatErrorMessage" },
        React.createElement("span", null, children),
        React.createElement(TextButton, { onClick: onCancelClick }, l10n.goBackButton)));
});
